import { useEffect, useRef } from 'react';

interface MatrixRainProps {
  active: boolean;
}

const MATRIX_CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ$#@%&*';

export function MatrixRain({ active }: MatrixRainProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!active || !canvasRef.current) {
      return;
    }

    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    if (!context) {
      return;
    }

    let animationFrame = 0;
    let drops: number[] = [];

    const resize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
      const columns = Math.floor(width / 16);
      drops = new Array(columns).fill(1);
    };

    resize();
    window.addEventListener('resize', resize);

    const render = () => {
      context.fillStyle = 'rgba(0, 0, 0, 0.08)';
      context.fillRect(0, 0, canvas.width, canvas.height);

      context.fillStyle = '#21ff57';
      context.font = '15px "IBM Plex Mono", monospace';

      drops.forEach((drop, index) => {
        const char = MATRIX_CHARS[Math.floor(Math.random() * MATRIX_CHARS.length)];
        const x = index * 16;
        const y = drop * 16;

        context.fillText(char, x, y);

        if (y > canvas.height && Math.random() > 0.975) {
          drops[index] = 0;
        }

        drops[index] += 1;
      });

      animationFrame = window.requestAnimationFrame(render);
    };

    render();

    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.removeEventListener('resize', resize);
      context.clearRect(0, 0, canvas.width, canvas.height);
    };
  }, [active]);

  if (!active) {
    return null;
  }

  return <canvas className="matrix-overlay" ref={canvasRef} aria-hidden="true" />;
}
